import type { AncestryDefinition, CharacterOptions } from '../../shared/game/character-build.js';

export const dwarf: AncestryDefinition = {
  id: 'dwarf', name: 'Dwarf', size: 'medium', trait: 'Stout', skillBonus: 0, initiativeBonus: 0,
  maxHitDiceBonus: 2, maxWoundsBonus: 1, speedBonus: -1,
  description: 'Dwarf, in the old language, means “stone.” You are resilient, solid, stout. Even when driven to exhaustion, you will not falter. Forgoing speed, you are gifted with physical vitality and a belly that can handle the finest (and worst) consumables this world has to offer.',
  traitDescription: '+2 max Hit Dice, +1 max Wounds, −1 Speed.',
  languages: [{ id: 'dwarvish', name: 'Dwarvish', minimumIntelligence: 0 }],
  languageDescription: 'You know Dwarvish if your INT isn’t negative.',
  skinColors: [0xf1c9a5, 0xe0ac87, 0xd5a384, 0xc99776, 0xa8714f, 0x8d5a3b, 0x6b4129, 0x4a2c1d, 0xb8b4ac, 0x96938d, 0x73736f, 0x515451],
};
export const dwarfBodies: CharacterOptions['bodies'] = [
  { id: 'dwarf-male', name: 'Masculine', height: [1.25, 1.5], ancestryId: 'dwarf' },
  { id: 'dwarf-female', name: 'Feminine', height: [1.2, 1.45], ancestryId: 'dwarf' },
];
